const { LocaleUrlStrategy } = require('@akinon/next/localization');
const { ROUTES } = require('@theme/routes');

const commerceUrl = encodeURI(
  process.env.SERVICE_BACKEND_URL ||
    'https://e3ae710f607140718a05bd9adcadaee1.lb.akinoncloud.com'
);
const extensionUrl = encodeURI(
  process.env.SERVICE_EXTENSION_URL ||
  'https://d7b6381e79914b35a22b3bd7910bdfea.lb.akinoncloud.com'
);

/** @type {import('@akinon/next/types').Settings} */
module.exports = {
  commerceUrl,
  usePrettyUrlRoute: true,
  extensionUrl,
  commonProductAttributes: [
    { translationKey: 'size', key: 'filterable_size' },
    { translationKey: 'size', key: 'integration_beden' },
    { translationKey: 'color', key: 'integration_renk_tonu' }
  ],
  localization: {
    locales: [
      {
        label: 'EN',
        value: 'en',
        localePath: 'en',
        apiValue: 'en-us',
        rtl: false
      },
      {
        label: 'TR',
        value: 'tr',
        localePath: 'tr',
        apiValue: 'tr-tr',
        rtl: false
      }
    ],
    currencies: [
      {
        label: 'USD',
        code: 'usd'
      },
      {
        label: 'TL',
        code: 'tl'
      }
    ],
    defaultLocaleValue: 'tr',
    localeUrlStrategy: LocaleUrlStrategy.HideDefaultLocale,
    redirectToDefaultLocale: true,
    defaultCurrencyCode: 'tl'
  },
  rewrites: [
    {
      source: ROUTES.AUTH,
      destination: '/auth'
    },
    {
      source: ROUTES.BASKET,
      destination: '/basket'
    },
    {
      source: ROUTES.ACCOUNT_ORDERS,
      destination: '/account/orders'
    }
  ],
  redis: {
    defaultExpirationTime: 900 // 15 min
  },
  checkout: {
    masterpassJsUrl: '/masterpass.json',
    iframeExcludedPaymentOptions: ['credit-card', 'masterpass']
  },
  customNotFoundEnabled: false
};
